import { resourceReducer, getResources } from 'redux-resource';

export default resourceReducer('sqlReports');

export const getSqlReports = (state, page = 1) =>
  getResources(state, `fetchSqlReports_${page}`);
export const getSqlReport = (state, id) => state.resources[id];
